import React, { useState, useEffect } from "react";
import Header1 from "../../Components/seperate Components/Header1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import "../../Styles/Redirecting Styles/FooterStyle/AboutCompany.css";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../Components/Footer";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Link } from "react-router-dom";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import pdf1 from "../../assets/company-pdf/Company-Profile.pdf";
import goal from "../../assets/icons/goal.png";
import axios from "axios";
// import deskOffice from "../../assets/All Images/desk-office.jpg";
// import discoverAmbrella from "../../assets/All Images/man-office.jpg";
import discoverAmbrella from "../../newimgs/who we are.png";

import potential from "../../assets/icons/potential.png";
import market from "../../assets/icons/market.png";
import reality from "../../assets/icons/graphic-design.png";
import { Helmet } from "react-helmet";
import dhiraj from "../../assets/All Images/Dhiraj.png";
import suruchi from "../../assets/All Images/Suruchi.png";
import shyam from "../../assets/All Images/Shyam.png";

const AboutUs = () => {
  var setting1 = {
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [isOpen, setOpen] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [isLoading, setLoading] = useState(false);

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);

    try {
      const response = await axios({
        method: "post",
        url: "https://mars.zithas.com/api/portfolio",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        axios({
          url: "https://mars.zithas.com/api/getpdf", //your url
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          alert("Plaese click ok button to Download Company Portfolio");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "company-porfolio.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [team, setTeam] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get("https://mars.zithas.com/api/team");
        setTeam(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, []);

  return (
    <div>
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content="Experience top-notch innovation with Ambrella – your go-to web and app development company. Delivering excellence through creativity."
        />
      </Helmet>

      <Header1 />

      {/* Banner section */}
      {/* <div
        className="bd-page-title-area bd-page-title-bg_about pt-120 pb-20"
        
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "38px", color: "#01536E" }}
                >
                  About Us
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Ambrella team is a diverse group of consultants and
                      industry experts, bringing a global perspective and a
                      strong team culture.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Second Section */}
<section id="domain-services" className="bd-choose-area fix pt-170 pb-80 aboutCompOne">
  <div className="container">
    <div className="bd-choose-shape">
      <div className="row">
        {/* ===== LEFT COLUMN (TEXT) ===== */}
        <div className="col-xl-6 col-lg-6 order-1 order-lg-1 pr-20 whoWeareText">
          <div className="bd-choose-text z-index text-center text-lg-start">
            <div className="bd-section-title-wrapper ">
              <h2 className="bd-section-title mb-15" style={{ fontSize: "38px" }}>Who we are!</h2>
              <h6
                className="bd-section-title mb-15"
                style={{ fontSize: "26px", lineHeight: "1.45" }}
              >
                Every journey starts with a tentative first step !!
              </h6>

              {/* ===== IMAGE (MOVED HERE FOR SMALL SCREENS) ===== */}
              <div className="d-block d-lg-none mb-4 pt-30">
                <img
                  src={discoverAmbrella}
                  className="resp-img"
                  alt="img not found"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>

              <p className="about-us para-about" style={{ fontSize: "16px" }}>
                Similar to most of the new-generation firms, Ambrella's
                genesis was also inspired by the indomitable human
                resilience in the aftermath of the COVID pandemic, that
                reshaped societies, economies, and the way we work and do
                business.
              </p>
              <p className="about-us para-about" style={{ fontSize: "16px" }}>
                With a wealth of experience of designing and implementing
                state-of-the-art processes, systems and applications in
                Fortune 100 organisations, Ambrella started its consulting
                journey in 2022.
              </p>
              <p className="about-us para-about" style={{ fontSize: "16px" }}>
                We have delivered value to our clients in the areas of
                Domain Consulting, IT Strategy, Application Development,
                Testing & Quality Assurance, Core Banking Implementation
                support so far.
              </p>
              <p className="about-us para-about" style={{ fontSize: "16px" }}>
                We also realize the importance of collaboration in today's
                world as we believe that problems are better solved
                together. We continue to add more partners into the
                'Ambrella' family to complement our core capabilities with
                specific arrow-head capabilities of our partners which
                enables us to reach out and serve more markets, more
                geographies, more sectors and more clients.
              </p>
              <p className="about-us para-about" style={{ fontSize: "16px" }}>
                As of 2025 August, we are present in India, Singapore and
                UAE. Our core team is 15 consultant strong , augmented by
                close to 400 consultants through our strategic partnerships.
              </p>
            </div>
          </div>
        </div>

        {/* ===== RIGHT COLUMN (IMAGE for large screens) ===== */}
        <div className="col-xl-6 col-lg-6 order-2 order-lg-2">
          <div className="bd-choose-img text-end top-resp z-index" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
            <div className="align-items-center custom-mar-15" style={{ width: "100%" }}>
              <div className="col-xl-12 col-lg-12 col-12 custom-pad-15 d-none d-lg-block">
                <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                  <img
                    src={discoverAmbrella}
                    className="resp-img"
                    alt="img not found"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
              </div>

              {/* <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                <div className="bd-choose-img-inner mb-15">
                  <img
                    src={service1}
                    className="resp-img"
                    className="resp-img bordertop-img2"
                    alt="img not found"
                  />
                </div>
                <div className="bd-choose-img-inner mb-15">
                  <img
                    src={service2}
                    className="resp-img bordertop-img3"
                    alt="img not found"
                  />
                </div>
              </div> */}
            </div>

            {/* <img
              className="bd-choose-shape bd-choose-shape-2"
              src={Shape2}
              alt="shape img not found"
            /> */}
            {/* <div className="bd-choose-video-popup">
              <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* <ModalVideo
    autoplay
    isOpen={isOpen}
    channel="youtube"
    videoId="2LRxhuDssLQ"
    onClose={() => setOpen(false)}
  ></ModalVideo>
  <button
    className="btn btn responsive_digital first_pop_video_business"
    onClick={() => setOpen(true)}
  >
    <FontAwesomeIcon
      icon={faPlay}
      className="play_bt_vid play_transition"
    />
  </button> */}
</section>


      {/* CTA */}

      {/* <section
        className="bd-video-area pt-60 pb-50"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section_about">
              <div className="bd-video-text">
                <p className="contact_section second-para-resp">
                  Linking Inspiration to{" "}
                  <span style={{ color: "#098FB4" }}>Excellence</span>
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section_about">
              <div className="contact-stuff_about">
                <div className="contact-stuff">
                  <div className="contact_icon icon_respon pt-15 pl-110">
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ fontSize: "30px" }}
                    />
                  </div>
                  <div className="contact_txt ">
                    <p className="contact-sub-text">CALL US NOW</p>
                    <a
                      href="tel:+65 87852030"
                      style={{ fontSize: "17px" }}
                      className="mbb-5 pb-20"
                    >
                      +65 87852030
                    </a>
                  </div>
                </div>
                <div className="contact_icon_about icon_respon mr-30">
                  <div className="bd-about-text-btn ">
                    <a
                      href={pdf1}
                      download
                      className="theme-btn mr-15 three-button-respon"
                      style={{
                        paddingRight: "25px",
                        paddingLeft: "25px",
                        backgroundColor: "#098FB4",
                      }}
                    >
                      <i
                        style={{
                          lineHeight: "4",
                          fontStyle: "normal",
                          color: "#fff",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faDownload}
                          style={{ fontSize: "20px", paddingRight: "10px" }}
                        />
                        Company Profile
                      </i>
                    </a>
                  </div>
                </div>
                <div className="contact_icon_about icon_respon_about">
                  <div className="bd-about-text-btn">
                    <button
                      className="theme-btn mr-15 "
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      style={{
                        paddingRight: "25px",
                        paddingLeft: "25px",
                        backgroundColor: "#098FB4",
                      }}
                    >
                      <i
                        style={{
                          lineHeight: "4",
                          fontStyle: "normal",
                          color: "#fff",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faDownload}
                          style={{ fontSize: "20px", paddingRight: "10px" }}
                        />
                        Our Porfolio
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{ width: "120%" }}>
                <div className="modal-header" style={{ border: "none" }}>
                  <h5 className="modal-title" id="exampleModalLabel">
                    Fill out the Details!
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ marginLeft: "50px" }}
                  ></button>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "100%", paddingRight: "25px" }}>
                    {isLoading ? (<Spinner/>) : ()} 
                    <form onSubmit={onHandleSubmit}>
                      <div className="row" style={{ paddingTop: "23px" }}>
                        <div className="bd-contact-field mb-20">
                          <input
                            className="blog-form"
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            style={{}}
                            placeholder="Name"
                            name="user_name"
                            required
                          />
                        </div>
                        <div className="bd-contact-field mb-20">
                          <input
                            type="email"
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                            name="user_email"
                            style={{}}
                            required
                          />
                        </div>
                        <div className="bd-contact-field mb-20 ">
                          <input
                            type="text"
                            placeholder="Contact No"
                            onChange={(e) => setMobile(e.target.value)}
                            name="user_contact"
                            style={{}}
                            required
                          />
                        </div>
                        <div className="col-12 mb-20">
                          <div className="bd-contact-field">
                            <button type="submit" className="theme-btn">
                              Download
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="hello">
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659453801/website/home/portfolio-side_y0lpqc.jpg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Third section */}
      {/* <section className="bd-choose-area fix pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape pb-70">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 third-section1-resp">
              
                <div className="bd-choose-img z-index mt-70">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={goal} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2 className="bd-choose-info-title mb-15">
                                Achieve Business Goal
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={reality} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2 className="bd-choose-info-title mb-15">
                                Turning Vision into Reality
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ml-15">
                      <div className="col mr-30">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src={market} />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2 className="bd-choose-info-title mb-15">
                              Understanding the Market
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src={potential} />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2 className="bd-choose-info-title mb-15">
                              Maximum Potential
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 third-section2-resp">
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title third-section-tittle">
                    Our vision drives us forward!
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p className="third-para">
                      Ambrella's long-term goal is to be a leading IT service
                      provider with a strong team of professionals. We aim to
                      expand our services and stay ahead in technology, helping
                      your business unlock its full potential.
                    </p>
                    <h4 className=" third-para ">
                      We stand by quality assurance and clear communication!
                    </h4>
                    <p className=" third-para">
                      We aim to deliver top-notch ideas to boost your business
                      and help it grow in the market. By blending creativity
                      with practical solutions, we lay the foundation for
                      success. Our commitment is to bring out the best in your
                      company through the services we offer.{" "}
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Fourth Section */}
      {/* <section className="bd-skill-area pb-10">
        <div className="bd-choose-shape">
          <div className="container" style={{ maxWidth: "1270px" }}>
            <div className="row">
              <div className="col-lg-6 fourth-about-section1">
                <div className="bd-section-title-wrapper mb-30">
                  <h3
                    className="bd-section-title mb-10"
                    style={{ fontSize: "46px" }}
                  >
                    Industries Covered
                  </h3>
                  <p>
                    With over 15 years of expertise, we have covered significant
                    industrial verticals all around the world. We have worked
                    with both small and medium-sized businesses and large
                    corporations. Zithas has developed its workforce's
                    capabilities to provide an advantage to any firm. We have
                    created and implemented products and services that have
                    enabled businesses to stay competitive.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 fourth-about-section2">
                <div className="container_new mb-30">
                  <div
                    className="pr-20 "
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip">
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/electric-bike_gwmeez.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/electric-bike_gwmeez.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/health-care_jejqsw.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/health-care_jejqsw.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/logistics_j73ggc.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/logistics_j73ggc.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                </div>
                <div className="container_new2">
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/security-tech_yavltg.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/security-tech_yavltg.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441373/website/about-us/travel-visa_yfhqui.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441373/website/about-us/travel-visa_yfhqui.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/many-more_fjotr6.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/many-more_fjotr6.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Fifth Section */}
      {/* <section className="bd-about-area gray-bg">
        <div className="bd-custom-container pt-70 pb-80">
          <div className="bd-about-four-bg pb-0 fix">
            <div className="bd-about-shape-box">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8 fifth-about-section1">
                    <div className="bd-about-img mb-30">
                      <div className="comments-box">
                        <div className="comments-avatar mt-80">
                          <img
                            src={deskOffice}
                            className="img-fluid"
                            style={{ borderRadius: "50%", width: "500px" }}
                            alt="img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 pl-30 fifth-about-section2">
                    <div className="bd-about-text bd-about-text-four z-index">
                      <div className="bd-section-title-wrapper">
                        <h1 className="bd-slider-five-title wow fadeInUp fifth-about-tittle">
                          Go with the Motto!{" "}
                        </h1>
                        <h2
                          className="bd-slider-five-subtitle wow fadeInUp fifth-about-tittle"
                          style={{ fontSize: "30px" }}
                        >
                          Delivering Top-Quality Services to Businesses
                        </h2>
                        <p className="mb-10 wow fadeInUp" data-wow-delay=".8s">
                          As founders, our main goal is to keep our clients
                          happy and support their business growth. We believe in
                          the motto, “You Grow, We Grow,” and always strive to
                          meet our clients' expectations.{" "}
                        </p>
                        <p className="mb-10 wow fadeInUp" data-wow-delay=".8s">
                          For us, Ambrella is more than just a business—it’s a
                          chance to learn, grow, and succeed. It keeps us driven
                          and inspires us to aim high and be the best!{" "}
                        </p>
                        <p className=" wow fadeInUp" data-wow-delay=".8s">
                          Understanding our clients' needs and delivering what
                          they expect is our top priority. We focus on
                          developing and implementing effective strategies to
                          create more business opportunities, helping our
                          clients actively engage and grow their businesses.{" "}
                        </p>
                        <p>
                          We aim to deliver top-notch ideas to boost your
                          business and help it grow in the market. By combining
                          creative thinking with practical solutions, we lay the
                          foundation for success. Our focus is on bringing out
                          the best in your company through the services we
                          provide.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className="bd-portfolio-area bd-portfolio-spacing pt-70 pb-70 aboutCompTwo">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-12">
              <div className="bd-section-title-wrapper text-center mb-30">
                {/* <h5 className="bd-section-subtitle mb-15 subtitle-without-border">
                  Visionary Team
                </h5> */}
                <h2 className="bd-section-title" style={{fontSize:"38px"}}>Meet the Team</h2>
                {/* <p>
                  We're a team of professionals who maintain and lead the
                  company with their immense efforts and great ideas.
                </p> */}
              </div>
            </div>
          </div>
          <div className="row mb-30">
            {/* <div className="col-lg-4 col-md-6">
              <div className="bd-portfolio mb-30">
                <img src={dhiraj} alt="porfolio not found" />
                <div className="bd-portfolio-text">
                  <h5 className="bd-team-four-title">Dhiraj Ranjan</h5>
                  <span className="pb-15">Partner Singapore</span>
                </div>
              </div>
              <p className="text-center" style={{fontSize:"16px"}}>
                Dhiraj powers Ambrella with close to 3 decades of experience in
                Customer Success & Operational Transformation.
              </p>
              <p className="text-center" style={{fontSize:"16px"}}>
                A veteran at Apple and Mastercard, he is a smart mix of passion
                and wisdom all set to lead Ambrella into the future.
              </p>
            </div> */}
            <div className="col-lg-6 col-md-6">
              <div className="bd-portfolio mb-30">
                <img src={suruchi} alt="porfolio not found" className="AboutImg" />
                <div className="bd-portfolio-text">
                  <h5 className="bd-team-four-title">Suruchi Dayalani</h5>
                  <span className="pb-15">Head, Strategic Partnerships</span>
                </div>
              </div>
              <p className="text-center" style={{fontSize:"16px"}}>
                Suruchi started her career in Fashion & Arts space<br/>and then
                transitioned to Technology where she<br/>now suffuses her creativity
                with code.
              </p>
              <p className="text-center" style={{fontSize:"16px"}}>
                She has the best job at Ambrella, that of<br/>constantly expanding our
                'Circle of Competence'<br/>by forging and sustaining partnerships.
              </p>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="bd-portfolio mb-30">
                <img src={shyam} alt="porfolio not found" className="AboutImg"/>
                <div className="bd-portfolio-text">
                  <h5 className="bd-team-four-title">Shyam Kurni</h5>
                  <span className="pb-15">Partner Middle East</span>
                </div>
              </div>
              <p className="text-center" style={{fontSize:"16px"}}>
                Shyam brings a wealth of Banking (especially <br/>Retail & Private
                Wealth Management) experience<br/>to Ambrella with his 25 years of
                experience in<br/>Product Management, Business Solutioning,<br/>
                Consulting and Program Management.
              </p>
              <p className="text-center" style={{fontSize:"16px"}}>
                An employee-turned-entrepreneur, he is a <br/>perfect blend of
                curiosity, creativity and<br/>camaraderie (in his own words).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Want to grow your business?
                </h2>
                <p className="contact_section second-para-resp">
                  You’ve come to the right place, at just the right time.
                </p>
                <p className="contact_subtext">
                  Achieve amazing results beyond expectations let’s get started
                  now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+65 87852030"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +65 87852030
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default AboutUs;
